module.exports = __webpack_public_path__ + "img/facebook.dd2b8c97.svg";